/** @format */

import React, { memo } from 'react';

import parse from 'html-react-parser';

interface Props {
  message: string;
}

export const ParsedContent = memo(({ message }: Props) => <div>{parse(message)}</div>);
